import { FormHelperText, TextFieldProps } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';
import { styled } from '@mui/material/styles';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';

interface IProps {
  name: string;
  label?: string;
  required?: boolean;
  onCountryChange?: (country) => void;
  whitelistCountries?: string[];
}

const PhoneInputStyled = styled(PhoneInput)(({ theme, disabled }) => ({
  '&.hasError': {
    '.form-control': {
      border: `1px solid ${theme.palette.error.main} !important`,
      '&:hover': {
        border: `1px solid ${theme.palette.error.main} !important`,
      },
      '&:focus': {
        border: `1px solid ${theme.palette.error.main} !important`,
        boxShadow: `0 0 0 1px ${theme.palette.error.main}`,
      },
    },
    '.special-label': {
      color: theme.palette.error.main,
    },
  },
  '.special-label': {
    color: theme.palette.text.disabled,
    background: `${theme.palette.background.paper} !important`,
    borderColor: theme.palette.text.primary,
    top: '-9px !important',
    left: '7px !important',
    lineHeight: '1.4375em',
    fontSize: '0.75rem !important',
    fontFamily: 'Public Sans,sans-serif',
    fontWeight: 400,
  },
  '.form-control': {
    width: '100% !important',
    background: `${theme.palette.background.paper} !important`,
    color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
    border: disabled
      ? `1px solid ${theme.palette.grey[300]} !important`
      : `1px solid ${theme.palette.grey[700]} !important`,
    '&:hover': {
      border: disabled
        ? `1px solid ${theme.palette.grey[300]} !important`
        : `1px solid ${theme.palette.text.primary} !important`,
    },
    '&:focus': {
      border: disabled
        ? `1px solid ${theme.palette.grey[300]} !important`
        : `1px solid ${theme.palette.text.primary} !important`,
    },
  },
  '.country-list': {
    background: `${
      theme.palette.mode === 'light'
        ? theme.palette.grey[200]
        : theme.palette.grey[700]
    } !important`,
    '.country': {
      '&:hover': {
        backgroundColor: `${
          theme.palette.mode === 'light'
            ? theme.palette.grey[300]
            : theme.palette.grey[800]
        } !important`,
      },
      '&.highlight': {
        backgroundColor: `${
          theme.palette.mode === 'light'
            ? theme.palette.grey[300]
            : theme.palette.grey[800]
        } !important`,
      },
    },
  },
}));

const FormHelperTextStyled = styled(FormHelperText)(() => ({
  margin: '8px 14px 0 14px !important',
}));

export default function RHFPhoneNumberField({
  name,
  label,
  required,
  onCountryChange,
  whitelistCountries,
  ...other
}: IProps & TextFieldProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, name }, fieldState: { error } }) => (
        <div style={{ width: '100%' }}>
          <PhoneInputStyled
            country={'us'}
            containerClass={error ? 'hasError' : ''}
            specialLabel={label ?? 'Phone'}
            onlyCountries={whitelistCountries}
            // @ts-ignore
            onChange={(value, countryData) => {
              // @ts-ignore
              const countryCode = countryData?.countryCode || 'US';
              if (onCountryChange && countryCode) {
                onCountryChange(countryCode.toUpperCase());
              }
              onChange(value);
            }}
            value={value}
            {...other}
          />
          {error && (
            <FormHelperTextStyled error={true}>
              {error.message}
            </FormHelperTextStyled>
          )}
        </div>
      )}
      rules={required ? { required } : {}}
    />
  );
}
